import React from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"

type CustomFabProps = {
  onClick: (e: React.MouseEvent) => void;
  children: React.ReactNode
}

export default function CustomFab(props: CustomFabProps) {
  const { onClick, children } = props

  return (
    <StyledFab id={"styled-fab"} onClick={onClick}>
      {children}
    </StyledFab>
  )
}

const StyledFab = styled(Stack)(({ theme }) => ({
  width: 64,
  height: 64,
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "none",
  position: "relative",
  background: theme.palette.primary["1"],
  borderRadius: "50%",
  zIndex: 100,

  "& svg": {
    width: 32,
    height: 32,
    stroke: theme.palette.primary["6"]
  }
}))
